import axios from 'axios'
import config from '@/config'

const uri = config.api.handling.shelterStatuses

const DEFAULT_PARAMS = {
  '$limit': 1000
}
export default {
  create (data) {
    return axios.post(uri, data)
  },
  get (params = {}) {
    return axios.get(uri, {
      params: {
        ...params,
        ...DEFAULT_PARAMS
      }
    })
  }
}
